import { createAction } from '@reduxjs/toolkit';

import type { Settings } from '../../types';
import types from '../actionTypes';

export const loadSettings = createAction(types.LOAD_SETTINGS);

export const loadSettingsSuccess = createAction(types.LOAD_SETTINGS_SUCCESS, (payload: Settings) => ({
    payload,
    meta: {
        lastSuccessAt: new Date().toISOString(),
    },
}));

export const loadSettingsFailure = createAction(types.LOAD_SETTINGS_FAILURE, (error: any) => ({
    payload: undefined,
    error,
}));
